import React from "react";

function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 110">
      <g data-name="Layer 2">
        <path fill="none" d="M0 0h150v110H0z" data-name="Rectangle 15168" />
        <g data-name="Group 1540">
          <g data-name="Group 1356">
            <g
              fill="none"
              stroke="#414042"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="3"
              data-name="Group 71"
            >
              <rect
                width="24"
                height="49"
                x="27.33"
                y="30.67"
                data-name="Rectangle 55"
                rx="5"
              />
              <circle cx="39.27" cy="68.49" r="1.64" data-name="Ellipse 11" />
              <rect
                width="61.85"
                height="40.79"
                x="60.82"
                y="30"
                data-name="Rectangle 56"
                rx="5"
              />
              <path d="M81.87 80h19.74" data-name="Line 27" />
              <path d="M91.74 70.79V80" data-name="Line 28" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default Icon;
